import { TuevLink } from './TuevLink'
import { observer } from 'mobx-react'
import { LegalText } from 'components/DigitalAccountCheck/IntroText/LegalText'
import { TrustCards } from './TrustCards'
import { DAC_IDLE_STEPS } from 'components/DigitalAccountCheck/helpers'
import { useRootStore } from 'stores/utils/hooks/useRootStore'

const DacFooterWrapper = observer(() => {
  const {
    rootStore: {
      traversal: { dacWidgetStep },
      navigation: { currentPageInSession }
    }
  } = useRootStore()

  const isDacPage =
    currentPageInSession && currentPageInSession?.indexOf('dac') > -1

  return (
    <>
      <TuevLink />
      <TrustCards />
      {isDacPage && dacWidgetStep === 'BANK_LOGIN_STEP' && <LegalText />}
    </>
  )
})

export { DacFooterWrapper }
